import {memo} from 'react';
import {styled, keyframes} from 'styled-components';
import {forbidExtraProps} from 'airbnb-prop-types';
import {string} from 'prop-types';
import {bgAccentMain, paragraph16, textPrimary} from 'r/Design';
import spinner from './spinner.png';

const spinnerAnimation = keyframes`
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
`;


const Content = styled.div`
  display: flex;
  width: 337px;
  padding: 44px 32px 40px 32px;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  background: ${bgAccentMain};
  box-shadow: 0px 4px 10px 0px rgba(170, 178, 197, 0.20);
  gap: 20px;
  border-radius: 8px;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Spinner = styled.div`
  width: 84px;
  height: 84px;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    width: 70px;
    height: 70px;
    top: 7px;
    left: 7px;
    background-size: cover;
    background-image: url(${spinner});
    animation: ${spinnerAnimation} .6s linear infinite;
  }
`;

const Message = styled.div`
  color: ${textPrimary};
  ${paragraph16}
`;


export default memo(ModalLoadingContent);

ModalLoadingContent.propTypes = forbidExtraProps({
  text: string,
});

function ModalLoadingContent({
  text,
}) {
  return (
    <Content>
      <Spinner/>
      {text && <Message>{text}</Message>}
    </Content>
  );
}
